import React from 'react';
import { getIntl } from '../../../../utils/intl';
import { Select } from '../../../v2BaseComponents/Inputs';
import { useSetEnvironment } from '../../../../hooks/api/useSetEnvironment';

const intl = getIntl('environmentToggle', {
    header: 'App Environment',
    dev: 'Development',
    prod: 'Production',
});

export type EnvironmentToggleOwnProps = {};

export type EnvironmentToggleProps = EnvironmentToggleOwnProps;

const EnvironmentToggle: React.FC<EnvironmentToggleProps> = () => {
    const { canSetEnvironment, setEnvironment, environment } = useSetEnvironment();
    if (!canSetEnvironment || environment === 'loading') return null;
    return (
        <Select
            title={intl('header')}
            selectOptions={[
                { label: intl('dev'), value: 'dev' },
                { label: intl('prod'), value: 'prod' },
            ]}
            value={environment}
            onChange={setEnvironment as any}
        />
    );
};

export default React.memo(EnvironmentToggle);
